/**
 * <trustpilot-rating> — refreshes the server-rendered Trustpilot rating line
 * (snippets/m-trustpilot-rating.liquid) with live data from Trustpilot's public
 * TrustBox endpoint: TrustScore, stars, label and review count.
 * If the request fails, the server-rendered values stay as they are.
 */
if (!customElements.get('trustpilot-rating')) {
  // Micro Combo template; its data payload carries score, stars, label and count.
  const TEMPLATE_ID = '5419b6ffb0d04a076446a9af';

  class TrustpilotRating extends HTMLElement {
    connectedCallback() {
      this.refresh();
    }

    async refresh() {
      const { businessUnitId } = this.dataset;
      if (!businessUnitId) return;

      const url = new URL(`https://widget.trustpilot.com/trustbox-data/${TEMPLATE_ID}`);
      url.searchParams.set('businessUnitId', businessUnitId);
      url.searchParams.set('locale', 'en-GB');

      try {
        const response = await fetch(url);
        if (!response.ok) return;
        const data = await response.json();
        const unit = data.businessUnit;
        if (!unit || typeof unit.trustScore !== 'number') return;

        this.render({
          score: unit.trustScore,
          stars: unit.stars,
          count: unit.numberOfReviews && unit.numberOfReviews.total,
          label: data.starsString,
        });
      } catch {
        // Network or parsing failure: keep the server-rendered fallback.
      }
    }

    /**
     * @param {{score: number, stars: number, count: number, label: string}} rating
     */
    render({ score, stars, count, label }) {
      const scoreText = score.toFixed(1);
      const countText = typeof count === 'number' ? count.toLocaleString('en-GB') : null;

      const scoreEl = this.querySelector('[data-tp-score]');
      if (scoreEl) scoreEl.textContent = scoreText;

      const countEl = this.querySelector('[data-tp-count]');
      if (countEl && countText) countEl.textContent = countText;

      const labelEl = this.querySelector('[data-tp-label]');
      if (labelEl && label) labelEl.textContent = label;

      if (typeof stars === 'number') {
        const full = Math.floor(stars);
        const half = stars > full;
        this.querySelectorAll('[data-tp-star]').forEach((star, index) => {
          const position = index + 1;
          star.classList.toggle('is-half', half && position === full + 1);
          star.classList.toggle('is-empty', position > full && !(half && position === full + 1));
        });
      }

      const link = this.querySelector('[data-tp-link]');
      if (link && countText) {
        link.setAttribute(
          'aria-label',
          `Rated ${scoreText} out of 5 from ${countText} reviews on Trustpilot`
        );
      }
    }
  }

  customElements.define('trustpilot-rating', TrustpilotRating);
}
